import DisabledReverseCharge from "@/module/Form/ReverseCharge/Strategy/DisabledReverseCharge";
import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";
import { ReverseChargeSetting } from "./ReverseChargeSetting";
import ForeignCustomerReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ForeignCustomerReverseChargeDeterminer";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";
import ForeignCustomerWithIcReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ForeignCustomerWithIcReverseChargeDeterminer";
import ForeignCustomerWithDicReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ForeignCustomerWithDicReverseChargeDeterminer";
import ForeignCustomerWithValidDicReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ForeignCustomerWithValidDicReverseChargeDeterminer";

export default class ReverseChargeDeterminerFactory {
  private readonly disabledReverseCharge: DisabledReverseCharge;
  private readonly foreignCustomerReverseCharge: ForeignCustomerReverseChargeDeterminer;
  private readonly foreignCustomerWithIcReverseCharge: ForeignCustomerWithIcReverseChargeDeterminer;
  private readonly foreignCustomerWithDicReverseCharge: ForeignCustomerWithDicReverseChargeDeterminer;
  private readonly foreignCustomerWithValidDicReverseCharge: ForeignCustomerWithValidDicReverseChargeDeterminer;

  constructor(
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    baseUrl: string,
    formPath: string,
  ) {
    this.disabledReverseCharge = new DisabledReverseCharge();
    this.foreignCustomerReverseCharge =
      new ForeignCustomerReverseChargeDeterminer(foreignCustomerDeterminer);
    this.foreignCustomerWithIcReverseCharge =
      new ForeignCustomerWithIcReverseChargeDeterminer(
        foreignCustomerDeterminer,
      );
    this.foreignCustomerWithDicReverseCharge =
      new ForeignCustomerWithDicReverseChargeDeterminer(
        foreignCustomerDeterminer,
      );
    this.foreignCustomerWithValidDicReverseCharge =
      new ForeignCustomerWithValidDicReverseChargeDeterminer(
        foreignCustomerDeterminer,
        baseUrl,
        formPath,
      );
  }

  create(reverseChargeSetting: string): ReverseChargeDeterminer {
    if (reverseChargeSetting === ReverseChargeSetting.DISABLED) {
      return this.disabledReverseCharge;
    }

    if (reverseChargeSetting === ReverseChargeSetting.FOREIGN_CUSTOMER) {
      return this.foreignCustomerReverseCharge;
    }

    if (
      reverseChargeSetting === ReverseChargeSetting.FOREIGN_CUSTOMER_WITH_IC
    ) {
      return this.foreignCustomerWithIcReverseCharge;
    }

    if (
      reverseChargeSetting === ReverseChargeSetting.FOREIGN_CUSTOMER_WITH_DIC
    ) {
      return this.foreignCustomerWithDicReverseCharge;
    }

    if (
      reverseChargeSetting ===
      ReverseChargeSetting.FOREIGN_CUSTOMER_WITH_VALID_DIC
    ) {
      return this.foreignCustomerWithValidDicReverseCharge;
    }

    throw new Error(
      'Unknown reverse charge determiner: "' + reverseChargeSetting + '".',
    );
  }
}
